import { motion } from "framer-motion";

// Slow, drifting aurora orbs for premium ambient depth (fixed, behind content).
export default function AuroraBackground() {
  const reduce = typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const orbs = [
    { c: "rgba(13,148,136,0.28)", s: 560, x: "-8%", y: "2%", d: 22 },
    { c: "rgba(6,182,212,0.22)", s: 620, x: "70%", y: "8%", d: 28 },
    { c: "rgba(16,185,129,0.16)", s: 520, x: "35%", y: "62%", d: 26 },
  ];
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" aria-hidden>
      <div className="absolute inset-0 bg-[radial-gradient(1200px_600px_at_50%_-10%,rgba(6,182,212,0.10),transparent)]" />
      {orbs.map((o, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full blur-[120px]"
          style={{ width: o.s, height: o.s, left: o.x, top: o.y, background: o.c }}
          animate={reduce ? {} : { x: [0, 40, -30, 0], y: [0, -30, 25, 0] }}
          transition={{ duration: o.d, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}
